import React from 'react'
import { getImgProps, Instructor as InstructorComponent } from '@superhi/design'

import { API } from 'src/api'

const IMAGE_PROPS_VERTICAL = {
  small: 100,
  medium: 50,
  large: 25,
  xlarge: 25,
}

type ComponentProps = Omit<
  React.ComponentProps<typeof InstructorComponent>,
  'image' | 'location' | 'facebook' | 'instagram' | 'twitter'
>

type Props = Omit<API.InstructorComponent, 'location' | 'jobTitle'> &
  ComponentProps & {
    location?: string
  }

const Instructor: React.FC<React.PropsWithChildren<Props>> = ({
  image,
  location,
  facebook,
  instagram,
  twitter,
  ...props
}) => {
  const imageProps = React.useMemo(() => getImgProps(image.url, IMAGE_PROPS_VERTICAL), [image])

  return (
    <InstructorComponent
      {...props}
      image={imageProps}
      location={location || undefined}
      facebook={facebook ? `http://facebook.com/${facebook}` : undefined}
      instagram={instagram ? `http://instagram.com/${instagram}` : undefined}
      twitter={twitter ? `http://twitter.com/${twitter}` : undefined}
    />
  )
}

export { default as FRAGMENT } from './fragments'
export default Instructor
